module.exports = __webpack_public_path__ + "img/team2.77370333.jpg";